// extracted by mini-css-extract-plugin
export default {"ranking":"ranking_ranking__wpl7J","ranking-container":"ranking_ranking-container__5kEPu","ranking-list":"ranking_ranking-list__Dvi29","ranking-table":"ranking_ranking-table__AQI-s"};